export default "__VITE_ASSET__DHakeIYR__"